import { Dispatch, SetStateAction } from "react";
import { TPortfolioCompany } from "../../const/const";
import { TableBody } from "../TableBody/TableBody";
import { TableLabels } from "../TableLabels/ui/TableLabels";

type TTableContentProps = {
  selectedRowIds: number[];
  handleCardChange: (id: number) => void;
  handleChangeAllCards: () => void;
  data: { portfolioCompanies: TPortfolioCompany[]; totalPortfolioCompanies: number };
  triggerRefetch: () => void;
  // companyHeaders: { value: string; label: string }[];
  limit: number;
  setPage: Dispatch<SetStateAction<number>>;
  currentPage: number;
  isLoading: boolean;
  className?: string;
};

export function TableContent({
  selectedRowIds,
  handleCardChange,
  handleChangeAllCards,
  data,
  triggerRefetch,
  // companyHeaders,
  setPage,
  limit,
  currentPage,
  isLoading,
  className
}: TTableContentProps) {
  return (
    <div className={className}>
      <TableLabels onChange={handleChangeAllCards} value={selectedRowIds.length > 0} />
      <TableBody
        selected={selectedRowIds}
        onChange={(id: number) => handleCardChange(id)}
        data={data}
        triggerRefetch={triggerRefetch}
        // companyHeaders={companyHeaders}
        limit={limit}
        setPage={setPage}
        currentPage={currentPage}
        isLoading={isLoading}
      />
    </div>
  );
}
